import { ReactNode, useState } from "react";

interface TooltipProps {
  children: ReactNode;
  content: string;
}

const Tooltip = ({ children, content }: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="inline-block relative">
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        className="inline-flex items-center cursor-help"
      >
        {children}
      </div>
      {isVisible && (
        <div className="-top-2 left-0 z-10 absolute bg-gray-900 shadow-sm px-3 py-2 rounded-lg w-max max-w-xs font-medium text-white text-sm -translate-y-full">
          {content}
          <div className="-bottom-1 left-[10px] absolute border-x-[6px] border-x-transparent border-t-[6px] border-t-gray-900"></div>
        </div>
      )}
    </div>
  );
};

export { Tooltip };
